// Local persistence for the onboarding questionnaire so answers survive refreshes,
// interrupted sessions and the sign-in redirect (same browser). Also mirrored to the
// backend for durability + analytics via the API.
const KEY = "narc.onboarding";

export function getAnswers() {
  try {
    return JSON.parse(window.localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
}

export function setAnswers(answers) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(answers || {}));
  } catch {}
}

export function clearAnswers() {
  try {
    window.localStorage.removeItem(KEY);
  } catch {}
}

export function hasCompletedOnboarding() {
  try {
    return window.localStorage.getItem("narc.onboarding_done") === "1";
  } catch {
    return false;
  }
}

export function markCompleted() {
  try {
    window.localStorage.setItem("narc.onboarding_done", "1");
  } catch {}
}

export const RELATIONSHIP_LABELS = {
  partner: "Partner or spouse",
  ex: "Ex-partner",
  dating: "Dating",
  family: "Family member",
  friend: "Friend",
  coworker: "Coworker",
  other: "Other",
};

export const HELP_LABELS = {
  screenshots: "Screenshot analysis",
  confusing: "Understanding confusing interactions",
  patterns: "Exploring possible manipulation patterns",
  communication: "Understanding communication",
  respond: "Deciding how to respond",
  boundaries: "Setting boundaries",
};
